export default "__VITE_ASSET__CZmJBP9n__"